<template>
  <div class="Output">
    <div
      v-if="error"
      class="heading error"
    >
      Error in project
    </div>
    <div
      v-else
      class="heading"
    >
      <div v-if="currentFile">
        <a
          class="title"
          href="#"
          @click.prevent="clearCurrentFile"
        >
          Preview
        </a>
        {{ currentFile }}
      </div>
      <div
        v-else
        class="title"
      >
        Preview
      </div>
    </div>
    <div class="output-container">
      <div
        v-if="error"
        class="error"
      >
        <div
          v-if="errorTitle"
          class="error-title my-2"
        >
          {{ errorTitle }}
        </div>
        <div v-if="errorDetails">
          Details:
          <ul>
            <li
              v-for="detail in errorDetails"
              :key="detail.loc"
            >
              <strong>{{ detail.loc }}</strong> - {{ detail.msg }}
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="currentFile">
        <!-- eslint-disable vue/no-v-html -->
        <pre v-html="currentFileContents" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
      <div v-else-if="output">
        <OutputFolder
          :node="output"
          root
          @show="onShowFile"
        />
      </div>
      <div
        v-else
        class="empty"
      >
        As you make changes to your project, output
        code and any errors in configuration will be shown here.
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Output {
  flex: 1;
  background: #333;
  display: flex;
  flex-direction: column;

  .heading {
    padding: 4px 8px;
    background-color: #fff;

    &.error {
      color: #f33;
    }

    .title {
      font-size: 1.2em;
      padding-right: 8px;
      margin-right: 8px;
      border-right: 1px solid rgba(0,0,0,.125);
    }
  }

  .output-container {
    width: 100%;
    min-height: calc(100vh - 200px);

    // Scroll overflow inside a flex container: https://stackoverflow.com/a/52489012
    flex: 1 1 1px;
    overflow: scroll;

    padding: 4px 4px 4px 8px;

    .error {
      color: #fa3;
    }

    p {
      color: #ccc;
    }

    pre {
      color: #aaa;
      font-size: 0.8em;
      width: max-content;
      overflow: visible;
    }

    .empty {
      color: #ccc;
      text-align: center;
      margin-top: 1em;
    }

  }

  .error-title {
    font-weight: bold;
  }
}
</style>

<script>
import highlight from '../../helpers/highlight'
import OutputFolder from './Folder.vue'

// Copied from app-builder/src/utils/api-client.js

export default {
  name: 'Preview',
  components: {
    OutputFolder
  },
  props: ['output', 'error'],
  data () {
    return {
      currentFile: null
    }
  },
  computed: {
    errorJSON () {
      if (!this.error) return null
      try {
        return JSON.parse(this.error)
      } catch (err) {
        return null
      }
    },
    errorTitle () {
      const error = this.errorJSON.error
      if (!error) return 'Unknown error'

      if (typeof error === 'string') return error
      return error.message || 'Unknown error'
    },
    errorDetails () {
      const error = this.errorJSON.error
      if (!error) return null
      return error.details
    },
    currentFileContents () {
      if (!this.currentFile) return null

      const parts = this.currentFile.split('/')
      let node = this.output

      while (node && typeof node !== 'string') node = node[parts.shift()]

      return highlight(this.currentFile, node)
    }
  },
  methods: {
    onShowFile (file) {
      this.currentFile = file
    },
    clearCurrentFile () {
      this.currentFile = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/preview/Preview.vue